import Pending from 'features/advance/screens/lightning/Pending/Pending';
import React from 'react';

export default function PendingPage() {
  return <Pending />;
}
